// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__3N0Q_","header":"PatientBlock_header__2FLyA","label":"PatientBlock_label__ERz3L","option":"PatientBlock_option__2dKiL"};